<script setup lang="ts">
import { tpgIconCheck, tpgIconError } from '@tpg/grammar-web-icons';
import { toTypedSchema } from '@vee-validate/yup';
import { useField } from 'vee-validate';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import type { GrammarTextFieldExpose } from '@nora-monorepo/grammar-ui';
import { GrammarTextField } from '@nora-monorepo/grammar-ui';
import { OPERATION_NAME_MAX_LENGTH } from '@nora-monorepo/shared';

import { createOperationNameSchema } from '#ui-shared/validation/operation-name.schema';

interface OperationNameInputProps {
  /**
   * Represents the vee-validate field path for the operation name.
   */
  name: string;
}

const props = defineProps<OperationNameInputProps>();
const operationNameRef = ref<GrammarTextFieldExpose | null>(null);
const { t } = useI18n();

const { value, errorMessage, meta } = useField<string>(() => props.name, toTypedSchema(createOperationNameSchema(t)), { validateOnMount: true });

defineExpose({ focus: () => operationNameRef.value?.focus() });
</script>

<template>
  <GrammarTextField
    ref="operationNameRef"
    :value="value"
    :label="t('operation.operationNameLabel')"
    :trailing-icon-template="meta.valid ? tpgIconCheck : tpgIconError"
    :form-associated="true"
    :counter="OPERATION_NAME_MAX_LENGTH"
    :type="meta.valid ? 'default' : 'error'"
    :message="errorMessage"
    @change="value = $event"
    @input="value = $event"
  />
</template>
